import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["data-test"]
const _hoisted_2 = ["poster"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "ds-quick-bet-card__lottery-icon-wrapper"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 2,
  class: "ds-quick-bet-card__divider ds-divider"
}
const _hoisted_9 = { class: "ds-quick-bet-card__body" }

import { computed, onMounted, ref } from "vue";
import { initQuickBetCardLists } from "../quick-bet-card/ds-quick-bet-card";
import DsSmileStatic from "../smiles/ds-smile-static.vue";
import {
    DsSmileStaticFacePosition as FacePosition,
    DsSmileStaticFaceType as FaceType,
} from "../smiles/ds-smile-static-types";
import WebpImage from "../image/webp-image.vue";

// lottery needs to be set to string, as we need to create multisazneka variant,
// and enum Lottery doesn't have multisazenka as key value pair


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-quick-bet-card',
  props: {
    heading: {},
    subheading: {},
    isWhiteCard: { type: Boolean, default: false },
    isSuccess: { type: Boolean, default: false },
    lottery: {},
    isInStorybook: { type: Boolean, default: false },
    dataTestValue: {},
    showVideo: { type: Boolean, default: false },
    showSmile: { type: Boolean, default: false },
    hideDivider: { type: Boolean, default: false },
    showLotteryIcon: { type: Boolean },
    isFallbackLotteryIcon: { type: Boolean, default: false },
    compressed: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const cardRoot = ref<HTMLElement>();

onMounted(() => {
    initQuickBetCardLists(cardRoot.value);
});

const getFallbackPoster = computed(() => {
    if (props.isInStorybook) return `/images/img/lotteries/kulicnik-bet-fallback.png`;
    return `/frontend/web/img/lotteries/ticket-check/kulicnik-bet-fallback.png`;
});

const getFallbackVideo = computed(() => {
    if (props.isInStorybook) return `/images/img/lotteries/kulicnik-bet.webm`;
    return `/frontend/web/img/lotteries/ticket-check/kulicnik-animation/kulicnik-bet.webm`;
});

const getFallbackIcon = computed(() => {
    if (props.isInStorybook) return `/images/img/lottery-settings/${props.lottery}/${props.lottery}-ico.png`;
    return `/frontend/web/img/lotteries/lottery-settings/${props.lottery}/${props.lottery}-ico.png`;
});

const getFallbackDefaultIcon = computed(() => {
    if (props.isInStorybook) return `/images/img/lottery-settings/default-ico.png`;
    return `/frontend/web/img/lotteries/lottery-settings/default-ico.png`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ds-quick-bet-card", [
            { 'ds-quick-bet-card--success': _ctx.isSuccess },
            { 'ds-quick-bet-card--white': _ctx.isWhiteCard },
            !!_ctx.lottery ? `ds-quick-bet-card--${_ctx.lottery}` : '',
            { 'ds-quick-bet-card--divider-hidden': _ctx.hideDivider },
            { 'ds-quick-bet-card--compressed': _ctx.compressed },
        ]]),
    ref_key: "cardRoot",
    ref: cardRoot,
    "data-test": _ctx.dataTestValue ? `quick-bet-${_ctx.dataTestValue}` : null
  }, [
    (_ctx.isSuccess && _ctx.showVideo)
      ? (_openBlock(), _createElementBlock("video", {
          key: 0,
          alt: "kulicnik loop animation",
          id: "bet-success-loop",
          constrols: "false",
          playsinline: "",
          autoplay: "",
          preload: "auto",
          class: "ds-quick-bet-card__animation",
          loop: "",
          muted: "",
          poster: getFallbackPoster.value
        }, [
          _createElementVNode("source", {
            src: getFallbackVideo.value,
            type: "video/webm"
          }, null, 8, _hoisted_3)
        ], 8, _hoisted_2))
      : (_ctx.showSmile)
        ? (_openBlock(), _createBlock(DsSmileStatic, {
            key: 1,
            class: "ds-quick-bet-card__smile",
            responsive: false,
            "face-position": _unref(FacePosition).LeftDown,
            "face-type": _unref(FaceType).BigSmile,
            "shadow-color": "black"
          }, null, 8, ["face-position", "face-type"]))
        : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["ds-quick-bet-card__header", { 'js-ds-quick-bet-card-header': !_ctx.isSuccess }])
    }, [
      (_ctx.showLotteryIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["ds-quick-bet-card__lottery-icon", { 'ds-quick-bet-card__lottery-icon--default': _ctx.isFallbackLotteryIcon }])
            }, [
              _createVNode(WebpImage, {
                class: "ds-quick-bet-card__lottery-icon-picture",
                "css-class": "ds-quick-bet-card__lottery-icon-img",
                src: _ctx.isFallbackLotteryIcon ? getFallbackDefaultIcon.value : getFallbackIcon.value,
                alt: `${_ctx.lottery} icon`,
                width: "24",
                height: "24",
                "is-in-storybook": _ctx.isInStorybook
              }, null, 8, ["src", "alt", "is-in-storybook"])
            ], 2),
            (_ctx.heading)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "ds-quick-bet-card__heading",
                  innerHTML: _ctx.heading,
                  "data-test": "quick-bet-title"
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.heading)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "ds-quick-bet-card__heading",
                  innerHTML: _ctx.heading,
                  "data-test": "quick-bet-title"
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ], 64)),
      (_ctx.subheading)
        ? (_openBlock(), _createElementBlock("p", {
            key: 2,
            class: "ds-quick-bet-card__subheading",
            innerHTML: _ctx.subheading
          }, null, 8, _hoisted_7))
        : _createCommentVNode("", true)
    ], 2),
    (!_ctx.hideDivider && !_ctx.isSuccess)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_8))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _renderSlot(_ctx.$slots, "button")
  ], 10, _hoisted_1))
}
}

})